import { render, staticRenderFns } from "./UNClassButton.vue?vue&type=template&id=90b2072a"
import script from "./UNClassButton.vue?vue&type=script&lang=js"
export * from "./UNClassButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports